// SSOT mirror for the warm-pool quantity options.
//
// Authoritative copy lives in backend/src/config/plans.js
// (ADDONS.warm_pool.quantityOptions). This file MUST stay in lock-step;
// if you change one, change the other in the same commit.
//
// Consumers also receive `pricing.quantityOptions` on
// GET /addons/warm-pool/status — UIs that already fetch the status
// should prefer that runtime value over this constant so live config
// changes propagate without a rebuild. This constant is the fallback
// for surfaces (e.g. marketplace deploy footer) that render BEFORE the
// status endpoint is reachable.

export const WARM_POOL_QUANTITY_OPTIONS = [1, 2, 3];
export const WARM_POOL_MAX_QUANTITY = Math.max(...WARM_POOL_QUANTITY_OPTIONS);
